'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-cowboy';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8ea';
var svgPathData = ['M104 184c0-4.5 .2-8.9 .7-13.3 31.5 12.5 70.2 21 116.8 21.3 .8 0 1.6 0 2.4 0s1.6 0 2.4 0c46.6-.3 85.4-8.7 116.8-21.3 .5 4.4 .7 8.8 .7 13.3 0 66.3-53.7 120-120 120S104 250.3 104 184z', 'M224 88c-45.3 0-81.6-7.5-108.8-16.6 11.6-51.9 32-103.4 63.8-103.4 9.6 0 18.5 4.3 26.6 9.5 5.6 3.6 12.1 6.5 18.4 6.5s12.9-2.9 18.4-6.5c8.1-5.2 17-9.5 26.6-9.5 31.8 0 52.2 51.6 63.8 103.4-27.2 9.1-63.5 16.6-108.8 16.6zM6.6 67C13 62.4 21.8 63.1 27.3 68.7 45.2 86.6 112.4 128 224 128S402.8 86.6 420.7 68.7c5.5-5.5 14.3-6.3 20.7-1.7s8.5 13.1 5 20.1C427.4 125.1 357.5 192 224 192S20.6 125.1 1.7 87.2c-3.5-7-1.4-15.5 5-20.1zM16 489.1C16 413.4 77.4 352 153.1 352l141.7 0c75.7 0 137.1 61.4 137.1 137.1 0 12.6-10.2 22.9-22.9 22.9L38.9 512C26.2 512 16 501.8 16 489.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserCowboy = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;